<template>
  <div class="page_content" v-html="content"></div>
</template>

<script>
export default {
  name: 'PageContent',

  props: {
    content: String
  }
}
</script>

<style>
:host {
  all: initial;
  display: block;
  contain: layout style;
}
#pdf-main .w0 {
  box-shadow: none;
  margin: 0 auto;
  max-width: 100%;
}
</style>
